import client from './axios'

const usersApi = {
  roles: () => {
    return client.get('user/roles/')
  },

  list: (page, page_size) => {
    const config = {params:{}};
    if (page !== null) config.params.page = page;
    if (page_size !== null) config.params.page_size = page_size;

    return client.get('user/', config)
  },

  add: (username, password, role_id) => {
    return client.post('user/register/', { username, password, role_id })
  },

  changePassword: (userId, password) => {
    return client.put(`user/${userId}/update-password`, { password })
  },

  changeOwnPassword: (current_password, new_password) => {
    return client.put('user/profile/update-password', { current_password, new_password })
  },

  deleteOwnAccount: (password) => {
    return client.post('user/profile/delete-account', { password })
  },

  exportOwnData: () => {
    return client.get('user/profile/export-data')
  },

  delete: (userId) => {
    return client.delete(`user/${userId}/delete`)
  },
}

export default usersApi
